// extracted by mini-css-extract-plugin
export default {"cardSearch":"styles-scoped__cardSearch--knovh","cardModalContent":"styles-scoped__cardModalContent--Wsy7v","cusBtn":"styles-scoped__cusBtn--fkJ00"};